import Vue from 'vue'
import VueRouter from 'vue-router'
import member from './member'
import system from './system'
import process from './process'
import home from './home'
import portal from './portal'

Vue.use(VueRouter)


const router = new VueRouter({
  // mode: 'history',
  routes: [
    ...home,
    ...member,
    ...system,
    ...process,
    ...portal
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js